export interface ErrorResponse {
  status?: number;
  data?: {
    title?: string;
    message?: string;
    messageToken?: string;
    detail?: string;
    errors?: Array<{ message: string }>;
    scope?: string;
    constraintViolations?: Record<string, { propertyPath: string; message: string; code?: string | null }>;
    violations?: Record<string, { propertyPath: string; message: string }>;
    errorTypeToken?: string;
    itemReferences?: unknown;
  };
}

// Shared shape for axios-style API errors as inspected in store catch blocks. Every field is
// optional, so this single type covers all callers (status-only checks as well as the
// scope/constraintViolations checks). Use the `isApiError` guard to narrow to it.
export interface ErrorObject {
  response?: ErrorResponse;
}

export function isApiError (error: unknown): error is ErrorObject {
  return typeof error === 'object' && error !== null && 'response' in error;
}
